import libphonenumber from 'google-libphonenumber';
import * as yup from 'yup';

export const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

yup.addMethod(yup.string, 'phone', function () {
  return this.test({
    name: 'phone',
    exclusive: true,
    message: 'Must be a phone number',
    test: (value) => {
      try {
        const phone = phoneUtil.parse(value, 'US');
        return phoneUtil.isValidNumber(phone);
      } catch (e) {
        if (!value) {
          return true;
        }
        return false;
      }
    },
  });
});
